var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWriting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_28_86)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8941 26.6041C61.4687 25.1588 59.1797 25.1108 57.6965 26.4595V10.0907C57.6965 9.48819 57.2151 9 56.6209 9H18.0756C17.4816 9 17 9.48819 17 10.0907V56.9093C17 57.5118 17.4816 58 18.0756 58H56.6208C57.215 58 57.6964 57.5118 57.6964 56.9093V37.2981L62.8763 32.0455C62.8792 32.0426 62.8813 32.0396 62.884 32.0368C62.8873 32.0336 62.8909 32.0309 62.8941 32.0277C64.3686 30.5323 64.3686 28.0993 62.8941 26.6041ZM19.1512 55.8186V11.1814H55.5452V28.6323L51.4307 32.8047C51.2682 32.7046 51.0783 32.6461 50.8744 32.6461H23.7216C23.1276 32.6461 22.646 33.1343 22.646 33.7368C22.646 34.3393 23.1276 34.8275 23.7216 34.8275H49.4357L46.9484 37.3497H23.7216C23.1276 37.3497 22.646 37.8379 22.646 38.4404C22.646 39.0429 23.1276 39.5311 23.7216 39.5311H44.7972L42.3098 42.0533H23.7216C23.1276 42.0533 22.646 42.5415 22.646 43.144C22.646 43.7465 23.1276 44.2347 23.7216 44.2347H40.1588L38.1801 46.2411C38.151 46.2707 38.1245 46.3016 38.0994 46.3335C38.0929 46.3419 38.0871 46.3508 38.0807 46.3594C38.0622 46.3844 38.0446 46.4098 38.0285 46.436C38.0225 46.4457 38.0168 46.4559 38.011 46.466C37.9954 46.4932 37.9812 46.5209 37.968 46.549C37.9653 46.555 37.9619 46.5602 37.9591 46.5662L37.7833 46.9639C37.6063 46.834 37.3895 46.7568 37.1546 46.7568H23.7216C23.1276 46.7568 22.646 47.245 22.646 47.8475C22.646 48.45 23.1276 48.9382 23.7216 48.9382H36.9105L35.5256 52.0705C35.5008 52.1267 35.4818 52.1843 35.4669 52.2427C35.186 52.8488 35.2902 53.5947 35.7833 54.0945C36.0877 54.4034 36.4925 54.5734 36.9233 54.5734C37.1678 54.5734 37.4031 54.5168 37.6174 54.4128C37.6722 54.3978 37.7265 54.3799 37.7793 54.356L43.2079 51.8884C43.2135 51.8858 43.2185 51.8824 43.2239 51.8797C43.2523 51.8663 43.2803 51.8516 43.3075 51.8353C43.317 51.8298 43.3265 51.8243 43.3357 51.8184C43.3625 51.8016 43.3884 51.7833 43.414 51.7638C43.4214 51.758 43.4293 51.7527 43.4368 51.7468C43.4685 51.7212 43.4993 51.6941 43.5285 51.6644L55.5452 39.4792V55.8186H19.1512ZM40.9037 50.5455L38.0972 51.8212C38.0855 51.8086 38.0751 51.7952 38.0631 51.7828C38.0511 51.7706 38.038 51.7601 38.0257 51.7483L39.2838 48.9028L40.9037 50.5455ZM42.768 49.351L40.4618 47.0125L58.2885 28.9356L60.5947 31.2742L42.768 49.351ZM61.8433 29.4552L60.0825 27.6697C60.5447 27.6303 61.0201 27.7887 61.373 28.1466C61.726 28.5043 61.882 28.9867 61.8433 29.4552Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_28_86",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_28_86"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_28_86",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriting);
export default __webpack_public_path__ + "static/media/writing.3fd77fdf96436b32c5b34f8b36800354.svg";
export { ForwardRef as ReactComponent };